module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card', {
    key: _vm.handler,
    staticClass: "ql-page",
    attrs: {
      "id": "ql-page"
    }
  }, [_c('md-card-media-cover', {
    ref: "cardCover",
    staticClass: "ql-page-cover",
    attrs: {
      "id": ("cardCover" + _vm.pageNumber)
    }
  }, [_c('div', {
    staticClass: "ql-pdf-page-wrapper",
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.ready) ? _c('project-pdf-thumbnail-page', {
    staticClass: "ql-pdf-page",
    class: {
      'disable-text': _vm.disableText
    },
    attrs: {
      "page": _vm.page,
      "pageWidth": _vm.pageWidth,
      "pageHeight": _vm.pageHeight,
      "currentLayer": _vm.currentLayer,
      "issrc": _vm.issrc
    },
    on: {
      "pdfLoaded": _vm.pdfLoaded,
      "openDialog": _vm.openDialog
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ql-page-number",
    on: {
      "click": function($event) {
        return _vm.handlePageOutClick()
      }
    }
  }, [(_vm.isAdministrator && !_vm.versionID) ? _c('md-input-container', {
    ref: "inputContainer",
    on: {
      "click": _vm.editNumber
    }
  }, [(_vm.project.pdfPageNumbers && _vm.project.pdfPageNumbers[_vm.pageIndex - 1] &&
    _vm.project.pdfPageNumbers[_vm.pageIndex - 1].name && _vm.project.pdfPageNumbers[_vm.pageIndex - 1].name) ? _c('md-input', {
    directives: [{
      name: "keydown",
      rawName: "v-keydown",
      value: (_vm.handleKeyDown),
      expression: "handleKeyDown"
    }],
    ref: "inputPageName",
    attrs: {
      "value": _vm.project.pdfPageNumbers[_vm.pageIndex - 1].name || _vm.pageNumber,
      "required": "",
      "disabled": _vm.locked
    },
    on: {
      "blur": _vm.pdfpageRename
    }
  }) : _c('md-input', {
    directives: [{
      name: "keydown",
      rawName: "v-keydown",
      value: (_vm.handleKeyDown),
      expression: "handleKeyDown"
    }],
    ref: "inputPageName",
    attrs: {
      "value": _vm.pageNumber,
      "required": "",
      "disabled": _vm.locked
    },
    on: {
      "blur": _vm.pdfpageRename
    }
  })], 1) : (_vm.versionID) ? _c('p', [_vm._v("\n                " + _vm._s(this.currentVersion.pdfPageNumbers && this.currentVersion.pdfPageNumbers[_vm.pageIndex - 1] &&
    this.currentVersion.pdfPageNumbers[_vm.pageIndex - 1].name && this.currentVersion.pdfPageNumbers[_vm.pageIndex - 1].name || _vm.pageNumber) + "\n            ")]) : _c('p', [_vm._v("\n                " + _vm._s(this.project.pdfPageNumbers && this.project.pdfPageNumbers[_vm.pageIndex - 1] &&
    this.project.pdfPageNumbers[_vm.pageIndex - 1].name && this.project.pdfPageNumbers[_vm.pageIndex - 1].name || _vm.pageNumber) + "\n            ")])], 1), _vm._v(" "), (!_vm.ready && !_vm.versionID) ? _c('p', [_vm._v("Loading PDF...")]) : _vm._e(), _vm._v(" "), _c('resize-sensor', {
    on: {
      "resize": _vm.resize
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b5d523","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/thumbnail-page.vue
// module id = 1267
// module chunks = 21